module.exports = __webpack_public_path__ + "img/Loading.636b92a8.png";